import './App.less';
import Footer from './Model/Footer';
import GalleryFull from './Model/GalleryFull';
import Header from './Model/Header';
import logo from './logo.jpeg';
import { useNavigate } from 'react-router-dom';
import ImageShow from './Model/ImageShow';

function OurGallery() {
  
  const navigate = useNavigate();
      const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems : [
    { 
      type: 'link', 
      name: 'Home', 
      link: '/',
      onClick: () => {
        
      navigate("/")
      }
    },
    { 
      type: 'link', 
      name: 'About', 
      link: '#about',
      onClick: () => {
         navigate("/aboutus")
      }
    },
    { 
      type: 'link', 
      name: 'Service', 
      link: '#why',
      
      onClick: () => {
         navigate("/service")
      }
    },
    { 
      type: 'link', 
      name: 'Gallery', 
      link: '/gallery',  // navigate to a separate route
       onClick: () => {
         navigate("/gallery")
      }
    },
    { 
      type: 'link', 
      name: 'Contact', 
      link: '#contact',
      onClick: () => {
         navigate("/contact")
      }
    }
  ]
  };

  const Brand = "Aspire Homes"
  return (
    <>
      <Header {...headerConfig} />
        <ImageShow image="/images/app/contact.png" title=" " />
      <GalleryFull/>
      <Footer></Footer>
    </>
  );
}

export default OurGallery;
